import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setPrompt } from "../../redux/promptSlice";

function PromptText({
  handleSubmit,
  allowSubmit,
  textareaRef,
  // templateMessage,
}) {
  const [isIMEComposing, setIsIMEComposing] = useState(false);
  const handleIMEStart = () => {
    setIsIMEComposing(true);
  };
  const handleIMEEnd = () => {
    setIsIMEComposing(false);
  };
  const prompt = useSelector((state) => state.prompt);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("effect: resize prompt listener");
    const resizeText = () => {
      const textarea = textareaRef.current;
      textarea.style.height = "auto";
      const textHeight = textarea.scrollHeight;
      textarea.style.height = textHeight + "px";
    };
    window.addEventListener("resize", resizeText);
    return () => {
      window.removeEventListener("resize", resizeText);
    };
  }, [textareaRef]);

  useEffect(() => {
    const resizeText = () => {
      const textarea = textareaRef.current;
      textarea.style.height = "auto";
      const textHeight = textarea.scrollHeight;
      textarea.style.height = textHeight + "px";
    };
    resizeText();
  });

  // useEffect(() => {
  //   console.log("effect: set prompt text");
  //   setText(templateMessage);
  // }, [templateMessage, setText]);

  return (
    <textarea
      rows="1"
      placeholder="Ask AI"
      className="w-full focus:ring-0 focus:outline-none bg-transparent py-1 text-lg"
      style={{
        resize: "none",
        maxHeight: "8rem",
      }}
      ref={textareaRef}
      value={prompt}
      onChange={(e) => {
        dispatch(setPrompt(e.target.value));
      }}
      onCompositionStart={handleIMEStart}
      onCompositionEnd={handleIMEEnd}
      onKeyDown={(e) => {
        // e.preventDefault(); // when pressing a key the order is onKeyDown then onChange. So this prevent will stop onChange receiving this input.
        if (e.key === "Enter") {
          e.preventDefault();
          if (!isIMEComposing && allowSubmit) {
            handleSubmit(e);
          }
        }
      }}
    ></textarea>
  );
}

export default PromptText;
